export default "__VITE_ASSET__oaPYSsvF__"